export default [
  {
    component: 'CNavItem',
    name: 'Start',
    to: '/start',
    icon: 'cil-speedometer',
    badge: {
      color: 'primary',
      text: 'Manager',
    },
  },
  {
    component: 'CNavItem',
    name: 'Szukaj wózka',
    to: '/jmp/parkMaszynowyAll',
    icon: 'cil-puzzle',
    color: 'color4',
    column: 1
  },
  {
    component: 'CNavItem',
    name: 'Klienci firmy',
    to: '/jmp/parkMaszynowyKlienci',
    icon: 'cil-group',
    color: 'color2',
    column: 1
  },
  {
    component: 'CNavItem',
    name: 'Sprzęt na stanie',
    to: '/jmp/parkMaszynowy',
    icon: 'cil-garage',
    color: 'color3',
    column: 1
  },
  {
    component: 'CNavItem',
    name: 'Sprzęt na wynajmnie',
    to: '/jmp/parkMaszynowyW',
    icon: 'cil-share-alt',
    color: 'color5',
    column: 1
  },
  {
    component: 'CNavGroup',
    name: 'Zlecenia handlowe',
    to: '/base',
    icon: 'cil-basket',
    color: 'color16',
    items: [
      {
        component: 'CNavItem',
        name: 'Sprzedaż',
        to: '/jmp/zleceniaHandloweSprzedaz',
        column: 2,
        longname: 'Zlecenia Sprzedaż',
        longcolor: 'color16',
        longicon: 'cil-basket'
      },
      {
        component: 'CNavItem',
        name: 'Wynajem',
        to: '/jmp/zleceniaHandloweWynajem',
        column: 2,
        longname: 'Zlecenia Wynajem',
        longcolor: 'color16',
        longicon: 'cil-basket'
      },
    ]
  },
  {
    component: 'CNavGroup',
    name: 'Zlecenia napraw',
    to: '/base',
    icon: 'cil-paint-bucket',
    color: 'color6',
    items: [
      {
        component: 'CNavItem',
        name: 'Zgłoszenia',
        to: '/jmp/zleceniaWarsztatowe',
        column: 2,
        longname: 'Naprawy zgłoszenia',
        longcolor: 'color6',
        longicon: 'cil-paint-bucket'
      },
      {
        component: 'CNavItem',
        name: 'Mobilne',
        to: '/jmp/zleceniaNaprawMobilne',
        column: 2,
        longname: 'Naprawy mobilne',
        longcolor: 'color6',
        longicon: 'cil-paint-bucket'
      },
      {
        component: 'CNavItem',
        name: 'Warsztatowe',
        to: '/jmp/zleceniaNaprawWarsztatowe',
        column: 2,
        longname: 'Naprawy warsztatowe',
        longcolor: 'color6',
        longicon: 'cil-paint-bucket'
      },
    ]
  },

  {
    component: 'CNavItem',
    name: 'Magazyn części',
    to: '/jmp/zleceniaCzesci',
    icon: 'cil-memory',
    color: 'color11',
    column: 3
  },
  {
    component: 'CNavGroup',
    name: 'Transport',
    to: '/base',
    icon: 'cil-truck',
    color: 'color15',
    items: [
      {
        component: 'CNavItem',
        name: 'Zlecenia',
        longname: 'Zlecenia transportowe',
        longicon: 'cil-truck',
        longcolor: 'color15',
        to: '/jmp/transport',
        column: 2
      },
      {
        component: 'CNavItem',
        name: 'Rozładunek',
        longname: 'Zlecenia rozładunku',
        longicon: 'cil-truck',
        longcolor: 'color15',
        to: '/jmp/zleceniaRozladunku',
        column: 2
      }
    ]
  },
  {
    component: 'CNavItem',
    name: 'Zadania',
    to: '/jmp/Zadania',
    icon: 'cil-options',
    color: 'color12',
    column: 3
  },
  {
    component: 'CNavItem',
    name: 'Moje zadania',
    to: '/jmp/MojeZadania',
    icon: 'cil-options',
    color: 'color12',
    column: 3
  },
  {
    component: 'CNavGroup',
    name: 'Raporty',
    to: '/base',
    icon: 'cil-print',
    color: 'color8',
    items: [
      {
        component: 'CNavItem',
        name: 'Przeglądy',
        to: '/jmp/raportPrzeglady',
        column: 4,
        longname: 'Raport Przeglądy',
        longcolor: 'color8',
        longicon: 'cil-print'
      },
      {
        component: 'CNavItem',
        name: 'Badania',
        to: '/jmp/raportBadania',
        column: 4,
        longname: 'Raport Badania',
        longcolor: 'color8',
        longicon: 'cil-print'
      },
      {
        component: 'CNavItem',
        name: 'Wynajem',
        to: '/jmp/raportWynajem',
        column: 4,
        longname: 'Raport Wynajem',
        longcolor: 'color8',
        longicon: 'cil-print'
      },
      {
        component: 'CNavItem',
        name: 'Historia wynajmów',
        to: '/jmp/araportWynajemAll',
        column: 4,
        longname: 'Raport Historia Wynajmów',
        longcolor: 'color8',
        longicon: 'cil-print'
      },
    ]
  },
  {
    component: 'CNavTitle',
    name: 'Konfiguracja',
  },
  {
    component: 'CNavItem',
    name: 'Zmień hasło',
    to: '/jmp/changePassword',
    icon: 'cil-shield-alt',
  },
  {
    component: 'CNavItem',
    name: 'Użytkownicy',
    to: '/jmp/users',
    icon: 'cil-user-plus',
  },
  {
    component: 'CNavItem',
    name: 'Listy kontrolne',
    to: '/jmp/listaCzynnosci',
    icon: 'cil-task',
  }
  ,
  {
    component: 'CNavItem',
    name: 'Szablony mailowe',
    to: '/jmp/szablony',
    icon: 'cib-gmail',
  }
]
